import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ec657b0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7ec657b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../data/code/fc/dpp/dppofficialwebsitev2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec657b0",
  null
  
)

export default component.exports